module.exports = __webpack_public_path__ + "img/navbar-logo-mobile.66c1f87a.png";